import {
  Container,
  Title,
  Text,
  Card,
  Stack,
  ThemeIcon,
} from '@mantine/core';
import { Calendar } from 'react-feather';

export function CoachSessionsPage() {
  return (
    <Container size="lg" py="xl">
      <Title order={2} mb="xl">
        My Sessions
      </Title>

      <Card withBorder padding="xl" radius="md">
        <Stack align="center" gap="md" py="xl">
          <ThemeIcon size={64} radius="xl" variant="light" color="gray">
            <Calendar size={32} />
          </ThemeIcon>
          <Title order={3} ta="center" c="dimmed">
            Sessions Coming Soon
          </Title>
          <Text size="sm" c="dimmed" ta="center" maw={400}>
            Your coaching sessions will be displayed here once you're assigned
            to cohorts. You'll be able to view upcoming sessions, session
            history, and manage your schedule.
          </Text>
        </Stack>
      </Card>
    </Container>
  );
}

export default CoachSessionsPage;
